import privateInstance from "../axios";
import axios from "axios";


export const asyncPostPaymentDetails = (data, setStep, setIsForm) => {
  return (dispatch) => {
    const url = `/payment/payment-details`;
    privateInstance
      .post(url, data)
      .then((res) => {
        const { message } = res.data;
        setStep(3);
        if (setIsForm) {
          setIsForm(true);
        }
      })
      .catch((err) => {
        console.log(err.response);
      });
  };
};

export const asyncSendOfferLetter = (data, setStep, setIsForm) => {
  return (dispatch) => {
    const url = `/user/offer-letter`;
    privateInstance
      .post(url, data)
      .then((res) => {
        const { message } = res.data;
        setIsForm(true);
      })
      .catch((err) => {
        console.log(err.response);
      });
  };
};

const setAllUserIpInfo = (data) => {
  return {
    type: "SET_USER_IP_INFO",
    payload: data,
  };
};

export const asyncGetMyIp = () => {
  return (dispatch) => {
    const url = "/user/user-nwinfo";
    privateInstance
      .get(url)
      .then((res) => {
        dispatch(setAllUserIpInfo(res.data.geoRes));
      })
      .catch((err) => {
        console.log(err);
      })


    // const url = "https://api.ipify.org/?format=json";
    // axios
    //   .get(url)
    //   .then((res) => {
    //     const origin = res.data.ip;
    //     // const countryurl = `https://ipapi.co/67.187.198.0/json/`;

    //     // us IP address
    //     // const countryurl = `https://ipapi.co/100.42.24.0/json/`;

    //     // romania ip
    //     // const countryurl = `https://ipapi.co/103.14.107.255/json/`;

    //     // spain ip
    //     // const countryurl = `https://ipapi.co/1.178.255.255/json/`;

    //     // china ip
    //     // const countryurl = `https://ipapi.co/1.0.63.255/json/`

    //     // uk ip address
    //     // const countryurl = `https://ipapi.co/2.24.0.0/json/`

    //     // uae ip address
    //     // const countryurl = `https://ipapi.co/103.152.183.255/json/`

    //     //germany ip
    //     // const countryurl = `https://ipapi.co/101.33.10.0/json/`;

    //     // kuwait IP
    //     // const countryurl = `https://ipapi.co/102.217.239.0/json/`

    //     // hungary ip
    //     // const countryurl = `https://ipapi.co/103.22.195.255/json/`

    //     // netherlands ip
    //     // const countryurl = `https://ipapi.co/185.156.172.142/json/`

    //     // austraila ip
    //     // const countryurl = `https://ipapi.co/1.0.0.255/json/`

    //     // denmark ip address
    //     // const countryurl = `https://ipapi.co/103.177.114.0/json/`

    //     //canada ip address
    //     // const countryurl = `https://ipapi.co/100.42.20.0/json/`;

    //     // morocco ip address
    //     // const countryurl = "https://ipapi.co/102.222.212.0/json/"

    //     // greece ip address 
    //     // const countryurl = "https://ipapi.co/102.38.248.0/json/";
        

    //     const countryurl = `https://ipapi.co/${origin}/json/`;

    //     axios
    //       .get(countryurl)
    //       .then((obj) => {
    //         // console.log(obj.data);
    //         dispatch(setAllUserIpInfo(obj.data));
    //       })
    //       .catch((err) => {
    //         console.log("THIS ERROR")
    //         console.log(err);
    //       });
    //   })
    //   .catch((err) => {
    //     console.log("OUTSIDE ERROR THIS ONE")
    //     console.log(err);
    //   });

  };
};


const setAllCurrency = (data) => {
  return {
    type: "SET_ALL_CURRENCY",
    payload: data,
  };
};

export const asyncCurrencyExchange = () => {
  return (dispatch) => {
    const url = "/payment/getcurrency";
    privateInstance
      .get(url)
      .then((res) => {
        dispatch(setAllCurrency(res.data.data.conversion_rates));
      })
      .catch((err) => {
        console.log(err.response);
      });
  };
};
